import { Link } from 'react-router-dom';

import { useIdioma } from '../../context/IdiomaContext';

import './Footer.css';

function Footer() {
  const { t } = useIdioma();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          <Link
            to="/"
            className="footer-logo"
          >
            JMMartin
          </Link>

          <p>
            {t('footer.descripcion')}

            <br />
            <br />

            {t('footer.formacion.doctorado')}

            <br />

            {t('footer.formacion.master')}

            <br />

            {t('footer.formacion.coach')}

            <br />

            {t('footer.formacion.formador')}
          </p>
        </div>

        <div className="footer-links">
          <h3>
            {t('footer.navegacion.titulo')}
          </h3>

          <Link to="/">
            {t('footer.navegacion.inicio')}
          </Link>

          <Link to="/sobre-mi">
            {t('footer.navegacion.sobreMi')}
          </Link>

          <Link to="/servicios">
            {t('footer.navegacion.servicios')}
          </Link>

          <Link to="/testimonios">
            {t(
              'footer.navegacion.testimonios'
            )}
          </Link>

          {/*
          <Link to="/blog">
            {t('footer.navegacion.blog')}
          </Link>
          */}
        </div>

        <div className="footer-contacto">
          <h3>
            {t('footer.contacto.titulo')}
          </h3>

          <Link to="/contacto">
            {t('footer.contacto.enlace')}
          </Link>
        </div>

        <div className="footer-redes">
          <h3>
            {t('footer.redesSociales')}
          </h3>

          <a
            href="https://www.linkedin.com/in/jos%C3%A9-manuel-mart%C3%ADn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>

          <a
            href="https://www.instagram.com/jmmartin_labs/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Instagram
          </a>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()}{' '}
          JMMartin.{' '}
          {t('footer.derechos')}
        </p>

        <div className="footer-legal">
          <Link to="/aviso-legal">
            {t('footer.legal.aviso')}
          </Link>

          <Link to="/privacidad">
            {t('footer.legal.privacidad')}
          </Link>

          <Link to="/cookies">
            {t('footer.legal.cookies')}
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;